import React from 'react'
import { useData } from '../DataProvider'
import { Label } from '../Label'
import { Input } from '../../../lib/ui/input'
import { Textarea } from '../../../lib/ui/textarea'
import DesiredLocation from './DesiredLocation'
import useTranslation from '../../shared/TranslationProvider'
import CharCounter from '../CharCounter'
import {
  Select,
  SelectTrigger,
  SelectContent,
  SelectItem,
  SelectValue,
} from '../../../lib/ui/select'
import OnboardingResumeUpload from '../OnboardingResumeUpload'

const Step3Default = () => {
  const {
    desiredJobTitle,
    desiredIndustry,
    linkedInProfile,
    setDesiredJobTitle,
    setLinkedInProfile,
    setDesiredIndustry,
    aboutYourself,
    setAboutYourself,
    candidateTimezone,
    setCandidateTimezone,
    time_zones,
  } = useData()

  const maxLength = 500
  const aboutCharCounterId = 'onboarding-about-char-counter'
  const linkedInDescriptionId = 'onboarding-step3-linkedin-description'

  const { t } = useTranslation()

  return (
    <>
      <div className="flex flex-col gap-8 border-r pr-4">
        <div>
          <Label htmlFor="desired-job-title">{t('step3.desired_title')}:</Label>
          <Input
            id="desired-job-title"
            type="text"
            className="mt-2"
            name="desired-job-title"
            value={desiredJobTitle}
            onChange={(e) => setDesiredJobTitle(e.target.value)}
          />
        </div>
        <DesiredLocation />
        <div>
          <Label htmlFor="desired-industry">
            {t('step3.desired_industry')}:
          </Label>
          <Input
            id="desired-industry"
            type="text"
            className="mt-2"
            name="desired-industry"
            value={desiredIndustry}
            onChange={(e) => setDesiredIndustry(e.target.value)}
          />
        </div>
        <div>
          <Label htmlFor="timezone">{t('step3.timezone')}:</Label>
          <Select
            value={candidateTimezone}
            onValueChange={setCandidateTimezone}
          >
            <SelectTrigger
              id="timezone"
              name="timezone"
              className="mt-2 bg-input-background"
            >
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {time_zones &&
                time_zones.map(([label, value]) => (
                  <SelectItem key={value} value={value}>
                    {label}
                  </SelectItem>
                ))}
            </SelectContent>
          </Select>
        </div>
        <OnboardingResumeUpload
          label={t('step3.resume.description')}
          subtext={t('step3.resume.subtext')}
        />
      </div>
      <div className="flex flex-col gap-8">
        <div>
          <Label htmlFor="linked-in-url">{t('step3.provide_linkedin')}:</Label>
          <p id={linkedInDescriptionId} className="pb-2 text-sm">
            {t('step3.linkedin_description')}
          </p>
          <Input
            id="linked-in-url"
            type="text"
            aria-describedby={linkedInDescriptionId}
            value={linkedInProfile}
            onChange={(e) => setLinkedInProfile(e.target.value)}
          />
        </div>
        <div className="flex flex-col">
          <Label htmlFor="about_yourself" className="pb-2">
            {t('step3.about_yourself')}:
          </Label>
          <Textarea
            id="about_yourself"
            aria-describedby={aboutCharCounterId}
            onChange={(e) => setAboutYourself(e.target.value)}
            value={aboutYourself}
            rows={10}
            maxLength={maxLength}
          />
          <CharCounter
            id={aboutCharCounterId}
            value={aboutYourself}
            maxLength={maxLength}
          />
        </div>
      </div>
    </>
  )
}

export default Step3Default
